import type { ReactNode } from "react";

/**
 * Content that slides open and shut: its height and opacity ease between nothing and full
 * (styles.css, still under reduced motion). While shut it stays in the page, so it can animate
 * closed, but is inert: nothing inside can be focused, tapped or read out.
 */
export function Reveal({ open, children }: { open: boolean; children: ReactNode }) {
  return (
    <div className="reveal" data-open={open} inert={!open}>
      <div className="reveal__inner">{children}</div>
    </div>
  );
}
